import { useMutation } from '@hooks/reactQuery';

import { organizationsCheckUniqueValues } from '@api/organisations';

import { ICheckUniqueValuesOrganisationsDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { EErrorCodes, TErrorCodes } from '@enums/errorCodes';

export const useMutateCheckUniqueOrganisationValues = () => {
	const {
		mutate: checkUniqueValuesOrganisations,
		isLoading: isLoadingCheckUniqueValuesOrganisations,
	} = useMutation<ICheckUniqueValuesOrganisationsDTO>({
		mutationKey: [],
		mutationFn: ({
			name,
			legalName,
			email,
			organizationId,
			successHandler,
			errorHandler,
		}: ICheckUniqueValuesOrganisationsDTO) => {
			organizationsCheckUniqueValues({
				name,
				legalName,
				email,
				organizationId,
			})
				.then(() => {
					successHandler();
				})
				.catch(err => {
					if (errorHandler) {
						const generateTextError = (errorCode: TErrorCodes): string | undefined => {
							return err?.errors?.find((item: any) => item.code === errorCode)?.message;
						};

						const nameError = generateTextError(EErrorCodes.nameAlreadyExists);
						const legalNameError = generateTextError(EErrorCodes.legalNameAlreadyExists);
						const emailError = generateTextError(EErrorCodes.emailAlreadyExists);

						errorHandler(prevState => ({
							...prevState,
							nameError: nameError,
							legalNameError: legalNameError,
							emailError: emailError,
						}));
					}
				});
		},
	});

	return {
		checkUniqueValuesOrganisations,
		isLoadingCheckUniqueValuesOrganisations,
	};
};
